import { keepPreviousData } from "@tanstack/react-query";

import { $api } from "@/shared/api";

import type { FriendsPeriod } from "../model/FRIENDS_PERIODS";
import { FRIENDS_POLL_INTERVAL_MS, isFriendsWaiting } from "./friendsPolling";

// Экран «Друзья» за период: бэкенд считает таблицу из базы, друзей из Steam грузит в фоне.
// При смене периода прошлая таблица видна, пока не придёт новая.
export const useFriends = (period: FriendsPeriod, refreshedAt: number | null) =>
  $api.useQuery(
    "get",
    "/api/friends",
    { params: { query: { period } } },
    {
      placeholderData: keepPreviousData,
      refetchInterval: ({ state }) =>
        isFriendsWaiting(state.data, state.dataUpdateCount, refreshedAt)
          ? FRIENDS_POLL_INTERVAL_MS
          : false,
    },
  );
